export enum SectionTileErrorEnum {
  ADD = 'ADD',
  DROP = 'DROP',
  WAITLIST_ADD = 'WAITLIST_ADD',
  WAITLIST_DROP = 'WAITLIST_DROP',
  SWAP = 'SWAP'
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/course_scheduler/types/section_tile_error_enum.ts